import operadora from '@static/menu/operadora';
import master from '@static/menu/master';
import comercializadora from '@static/menu/comercializadora';
import grupo from '@static/menu/grupo';
import administrador from '@static/menu/administrador';
import soporte from '@static/menu/soporte';
import sistema from '@static/menu/sistema';
import operadora_loteria from '@static/menu/operadora-loteria';
import supervisor from '@static/menu/supervisor';

export default {
    namespaced: true,
    state: () => ({
        items: {
            'operadora': operadora,
            'master': master,
            'comercializadora': comercializadora,
            'grupo': grupo,
            'administrador': administrador,
            'soporte': soporte,
            'operadora-loteria': operadora_loteria,
            'sistema': sistema,
            'supervisor': supervisor,
        },
        drawer: false,
    }),
    getters: {
        get: state => (domain) => state.items[domain] || [],
        getDrawer: state => state.drawer,
    },
    mutations: {
        switchDrawer: (state) => {
            state.drawer = !state.drawer;
        },
        setDrawer: (state, drawer) => {
            state.drawer = drawer;
        },
    },
    actions: {
        switchDrawer: ({ commit }) => {
            commit('switchDrawer');
        },
        setDrawer: ({ commit }, drawer) => {
            commit('setDrawer', drawer);
        },
    }
}